import { type PollContentObjectDetail, createPollContentObjectDetail } from 'models';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { useContentObjectCache } from 'features/feed/queries/cache';
import type { PollSubmitData } from '../../form/PollForm';
import { updatePoll } from '../../services';

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
export const useUpdatePollMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<PollContentObjectDetail, PollSubmitData>({
    async mutationFn(poll) {
      const response = await updatePoll(poll);

      return createPollContentObjectDetail(response.data);
    },
    onSuccess(data) {
      cache.replace(data);
    },
  });
};
